import RequireDevice from './RequireDevice';

export default RequireDevice;
